/* Searchable phone country-code picker for [data-cfs-phone] (waiting-list form). Sends "+41 79 123 45 67".
   Progressive enhancement: without JS the plain tel input works. No libraries, no network requests. */
(function () {
  if (window.cfsPhone) return;
  window.cfsPhone = { init: init };

  // ISO2|English name|full dialling digits|optional search aliases. NANP members carry their area code (1242).
  var DATA =
  'AF|Afghanistan|93;AX|Åland Islands|358;AL|Albania|355;DZ|Algeria|213;AS|American Samoa|1684;AD|Andorra|376;' +
  'AO|Angola|244;AI|Anguilla|1264;AG|Antigua and Barbuda|1268;AR|Argentina|54;AM|Armenia|374;AW|Aruba|297;' +
  'AC|Ascension Island|247;AU|Australia|61;AT|Austria|43|osterreich;AZ|Azerbaijan|994;BS|Bahamas|1242;' +
  'BH|Bahrain|973;BD|Bangladesh|880;BB|Barbados|1246;BY|Belarus|375;BE|Belgium|32;BZ|Belize|501;BJ|Benin|229;' +
  'BM|Bermuda|1441;BT|Bhutan|975;BO|Bolivia|591;BA|Bosnia and Herzegovina|387;BW|Botswana|267;BR|Brazil|55;' +
  'IO|British Indian Ocean Territory|246;VG|British Virgin Islands|1284;BN|Brunei|673;BG|Bulgaria|359;' +
  'BF|Burkina Faso|226;BI|Burundi|257;KH|Cambodia|855;CM|Cameroon|237;CA|Canada|1;CV|Cape Verde|238|cabo verde;' +
  'BQ|Caribbean Netherlands|599;KY|Cayman Islands|1345;CF|Central African Republic|236;TD|Chad|235;' +
  'CL|Chile|56;CN|China|86;CX|Christmas Island|61;CC|Cocos (Keeling) Islands|61;CO|Colombia|57;KM|Comoros|269;' +
  'CG|Congo|242;CD|Congo (DRC)|243|democratic republic;CK|Cook Islands|682;CR|Costa Rica|506;' +
  'CI|Côte d\'Ivoire|225|ivory coast;HR|Croatia|385;CU|Cuba|53;CW|Curaçao|599;CY|Cyprus|357;' +
  'CZ|Czechia|420|czech republic;DK|Denmark|45;DJ|Djibouti|253;DM|Dominica|1767;DO|Dominican Republic|1809;' +
  'EC|Ecuador|593;EG|Egypt|20;SV|El Salvador|503;GQ|Equatorial Guinea|240;ER|Eritrea|291;EE|Estonia|372;' +
  'SZ|Eswatini|268|swaziland;ET|Ethiopia|251;FK|Falkland Islands|500;FO|Faroe Islands|298;FJ|Fiji|679;' +
  'FI|Finland|358;FR|France|33;GF|French Guiana|594;PF|French Polynesia|689;GA|Gabon|241;GM|Gambia|220;' +
  'GE|Georgia|995;DE|Germany|49|deutschland;GH|Ghana|233;GI|Gibraltar|350;GR|Greece|30;GL|Greenland|299;' +
  'GD|Grenada|1473;GP|Guadeloupe|590;GU|Guam|1671;GT|Guatemala|502;GG|Guernsey|44;GN|Guinea|224;' +
  'GW|Guinea-Bissau|245;GY|Guyana|592;HT|Haiti|509;HN|Honduras|504;HK|Hong Kong|852;HU|Hungary|36;IS|Iceland|354;' +
  'IN|India|91;ID|Indonesia|62;IR|Iran|98;IQ|Iraq|964;IE|Ireland|353;IM|Isle of Man|44;IL|Israel|972;' +
  'IT|Italy|39;JM|Jamaica|1876;JP|Japan|81;JE|Jersey|44;JO|Jordan|962;KZ|Kazakhstan|7;KE|Kenya|254;' +
  'KI|Kiribati|686;XK|Kosovo|383;KW|Kuwait|965;KG|Kyrgyzstan|996;LA|Laos|856;LV|Latvia|371;LB|Lebanon|961;' +
  'LS|Lesotho|266;LR|Liberia|231;LY|Libya|218;LI|Liechtenstein|423;LT|Lithuania|370;LU|Luxembourg|352;' +
  'MO|Macao|853|macau;MG|Madagascar|261;MW|Malawi|265;MY|Malaysia|60;MV|Maldives|960;ML|Mali|223;MT|Malta|356;' +
  'MH|Marshall Islands|692;MQ|Martinique|596;MR|Mauritania|222;MU|Mauritius|230;YT|Mayotte|262;MX|Mexico|52;' +
  'FM|Micronesia|691;MD|Moldova|373;MC|Monaco|377;MN|Mongolia|976;ME|Montenegro|382;MS|Montserrat|1664;' +
  'MA|Morocco|212;MZ|Mozambique|258;MM|Myanmar|95|burma;NA|Namibia|264;NR|Nauru|674;NP|Nepal|977;' +
  'NL|Netherlands|31|holland;NC|New Caledonia|687;NZ|New Zealand|64;NI|Nicaragua|505;NE|Niger|227;NG|Nigeria|234;' +
  'NU|Niue|683;NF|Norfolk Island|672;KP|North Korea|850;MK|North Macedonia|389;MP|Northern Mariana Islands|1670;' +
  'NO|Norway|47;OM|Oman|968;PK|Pakistan|92;PW|Palau|680;PS|Palestine|970;PA|Panama|507;PG|Papua New Guinea|675;' +
  'PY|Paraguay|595;PE|Peru|51;PH|Philippines|63;PL|Poland|48;PT|Portugal|351;PR|Puerto Rico|1787;QA|Qatar|974;' +
  'RE|Réunion|262;RO|Romania|40;RU|Russia|7;RW|Rwanda|250;BL|Saint Barthélemy|590;SH|Saint Helena|290;' +
  'KN|Saint Kitts and Nevis|1869;LC|Saint Lucia|1758;MF|Saint Martin|590;PM|Saint Pierre and Miquelon|508;' +
  'VC|Saint Vincent and the Grenadines|1784;WS|Samoa|685;SM|San Marino|378;' +
  'ST|São Tomé and Príncipe|239;SA|Saudi Arabia|966;SN|Senegal|221;RS|Serbia|381;SC|Seychelles|248;' +
  'SL|Sierra Leone|232;SG|Singapore|65;SX|Sint Maarten|1721;SK|Slovakia|421;SI|Slovenia|386;SB|Solomon Islands|677;' +
  'SO|Somalia|252;ZA|South Africa|27;KR|South Korea|82;SS|South Sudan|211;ES|Spain|34;LK|Sri Lanka|94;' +
  'SD|Sudan|249;SR|Suriname|597;SJ|Svalbard and Jan Mayen|47;SE|Sweden|46;' +
  'CH|Switzerland|41|schweiz suisse svizzera;SY|Syria|963;TW|Taiwan|886;TJ|Tajikistan|992;TZ|Tanzania|255;' +
  'TH|Thailand|66;TL|Timor-Leste|670|east timor;TG|Togo|228;TK|Tokelau|690;TO|Tonga|676;' +
  'TT|Trinidad and Tobago|1868;TA|Tristan da Cunha|290;TN|Tunisia|216;TR|Türkiye|90|turkey;' +
  'TM|Turkmenistan|993;TC|Turks and Caicos Islands|1649;TV|Tuvalu|688;UG|Uganda|256;UA|Ukraine|380;' +
  'AE|United Arab Emirates|971|uae;GB|United Kingdom|44|uk england;US|United States|1|usa;' +
  'UY|Uruguay|598;VI|US Virgin Islands|1340;UZ|Uzbekistan|998;VU|Vanuatu|678;VA|Vatican City|39|holy see;' +
  'VE|Venezuela|58;VN|Vietnam|84;WF|Wallis and Futuna|681;EH|Western Sahara|212;YE|Yemen|967;ZM|Zambia|260;' +
  'ZW|Zimbabwe|263';
  var TOP = ['CH', 'DE', 'FR', 'IT', 'AT', 'LI'];
  var MAIN = ',US,GB,RU,NO,FI,GP,CW,AU,RE,MA,IT,SH,'; // listed first when several share a code
  var KEEP0 = ',IT,SM,VA,'; // the leading 0 is part of the number
  var all = [], byIso = {}, uid = 0, open = null;

  // Lower case, no accents, punctuation as single spaces.
  function norm(s) {
    return String(s).normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  }
  function nanp(c) { return c.d.length === 4 && c.d.charAt(0) === '1'; }

  // Country names in the page language (French on the French site); the English name stays searchable.
  var LANG = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase(), DN = null;
  try { if (LANG !== 'en' && window.Intl && Intl.DisplayNames) DN = new Intl.DisplayNames([LANG], { type: 'region' }); } catch (e) {}

  DATA.split(';').forEach(function (s) {
    var p = s.split('|'), name = p[1];
    if (DN) { try { var ln = DN.of(p[0]); if (ln && ln !== p[0]) name = ln; } catch (e) {} }
    var c = { iso: p[0], n: name, d: p[2], main: MAIN.indexOf(',' + p[0] + ',') > -1 };
    c.key = norm(name);
    c.alias = ' ' + norm((DN ? p[1] + ' ' : '') + (p[3] || '')) + ' ';
    c.words = ' ' + c.key + c.alias;
    c.f = String.fromCodePoint(0x1F1A5 + p[0].charCodeAt(0), 0x1F1A5 + p[0].charCodeAt(1));
    c.c = '+' + (nanp(c) ? '1 ' + c.d.slice(1) : c.d);
    all.push(c);
    byIso[p[0]] = c;
  });
  all.sort(function (a, b) { return a.n.localeCompare(b.n, LANG); });
  var top = TOP.map(function (i) { return byIso[i]; });
  all = top.concat(all.filter(function (c) { return top.indexOf(c) < 0; }));
  all.forEach(function (c, i) { c.i = i; });

  // Ranked matches for a query. Digits search the dialling code, anything else the name / ISO code.
  function search(raw) {
    var q = raw.trim(), out = [];
    if (/^[\d\s()+.-]+$/.test(q)) q = q.replace(/\D/g, '').replace(/^00/, '');
    if (!q) return all.slice();
    if (/^\d+$/.test(q)) {
      all.forEach(function (c) {
        var t = c.d === q ? (c.main ? 0 : 1) : c.d.indexOf(q) === 0 ? 2 : nanp(c) && c.d.slice(1) === q ? 3 : -1;
        if (t > -1) out.push({ c: c, t: t, s: (c.d.length * 1e4 + +c.d) * 2 + (c.main ? 0 : 1) });
      });
    } else {
      q = norm(q).replace(/^st /, 'saint ');
      if (!q) return all.slice();
      all.forEach(function (c) {
        var t = c.iso.toLowerCase() === q || c.alias.indexOf(' ' + q + ' ') > -1 ? 0 : c.key.indexOf(q) === 0 ? 1 :
          c.words.indexOf(' ' + q) > -1 ? 2 : c.key.indexOf(q) > -1 ? 3 : -1;
        if (t > -1) out.push({ c: c, t: t, s: 0 });
      });
    }
    out.sort(function (a, b) { return a.t - b.t || a.s - b.s || a.c.i - b.c.i; });
    return out.map(function (o) { return o.c; });
  }

  function render(r) {
    var html = '';
    r.res.forEach(function (c, k) {
      html += '<li role="option" id="' + r.id + '-' + c.iso + '" data-iso="' + c.iso +
        '" class="cfs-phone__opt' + (c === r.cur ? ' is-current' : '') + (!r.q && k === TOP.length ? ' is-split' : '') +
        '"><span class="cfs-phone__oflag" aria-hidden="true">' + c.f + '</span><span class="cfs-phone__name">' + c.n +
        '</span><span class="cfs-phone__dial">' + c.c + '</span></li>';
    });
    r.list.innerHTML = html;
    r.empty.hidden = r.res.length > 0;
    r.act = -1;
  }

  function setActive(r, k, scroll) {
    var opts = r.list.children, o = opts[r.act];
    if (o) { o.classList.remove('is-active'); o.removeAttribute('aria-selected'); }
    r.act = k;
    o = opts[k];
    if (!o) return r.search.removeAttribute('aria-activedescendant');
    o.classList.add('is-active');
    o.setAttribute('aria-selected', 'true');
    r.search.setAttribute('aria-activedescendant', o.id);
    if (scroll) o.scrollIntoView({ block: 'nearest' });
  }

  function filter(r) {
    r.q = !!r.search.value.trim();
    r.res = search(r.search.value);
    render(r);
    setActive(r, r.q ? 0 : r.res.indexOf(r.cur), false);
    r.list.scrollTop = 0;
  }

  function expand(r, on) {
    r.panel.hidden = !on;
    r.btn.setAttribute('aria-expanded', on);
    r.search.setAttribute('aria-expanded', on);
  }

  function openPanel(r) {
    if (open && open !== r) closePanel(open, false);
    open = r;
    expand(r, true);
    r.search.value = '';
    filter(r);
    var o = r.list.children[r.act];
    if (o) r.list.scrollTop = o.offsetTop - (r.list.clientHeight - o.offsetHeight) / 2;
    r.search.focus();
  }

  function closePanel(r, refocus) {
    if (open === r) open = null;
    if (r.panel.hidden) return;
    expand(r, false);
    r.search.removeAttribute('aria-activedescendant');
    if (refocus) r.btn.focus();
  }

  function pick(r, c) {
    r.cur = c;
    r.btn.innerHTML = '<span class="cfs-phone__flag" aria-hidden="true">' + c.f + '</span><span class="cfs-phone__code">' +
      c.c + '</span><span class="cfs-phone__chev" aria-hidden="true"></span>';
    r.btn.setAttribute('aria-label', r.label + ': ' + c.n + ' ' + c.c);
  }

  function choose(r, c) {
    pick(r, c);
    closePanel(r, false);
    r.tel.focus();
  }

  // International format on submit. "+..." stays, "00..." becomes "+...", else drop one trunk 0 and add the code.
  function compose(r) {
    var tel = r.tel, v = tel.value.trim(), c = r.cur, n;
    if (!v || v.charAt(0) === '+') return;
    if (v.slice(0, 2) === '00') { tel.value = '+' + v.slice(2).trim(); return; }
    if (v.charAt(0) === '0' && KEEP0.indexOf(',' + c.iso + ',') < 0) v = v.slice(1).trim();
    if (!v) return;
    if (c.d.charAt(0) === '1') {
      n = v.replace(/\D/g, '');
      if (n.length === 11 && v.charAt(0) === '1') { v = v.replace(/^1[\s.-]*/, ''); n = n.slice(1); }
      // NANP number typed with its area code ("242 359 1234"): do not repeat the area code.
      if (nanp(c) && n.length === 10 && n.indexOf(c.d.slice(1)) === 0) { tel.value = '+1 ' + v; return; }
    }
    tel.value = c.c + ' ' + v;
  }

  function setup(el) {
    if (el.cfsPhone) return;
    var tel = el.querySelector('.cfs-phone__row input');
    if (!tel) return;
    var id = 'cfs-phone-' + (++uid);
    var label = el.getAttribute('data-button-label') || 'Country code';
    var r = el.cfsPhone = { el: el, tel: tel, id: id, label: label, act: -1, res: [] };
    var dlg = el.closest('dialog'), form = el.closest('form');

    var btn = r.btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'cfs-phone__btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id + '-panel');
    tel.parentNode.insertBefore(btn, tel);

    var p = r.panel = document.createElement('div');
    p.className = 'cfs-phone__panel';
    p.id = id + '-panel';
    p.hidden = true;
    p.innerHTML = '<input type="search" class="cfs-phone__search" role="combobox" aria-autocomplete="list" aria-expanded="false"' +
      ' aria-controls="' + id + '-list" autocomplete="off" spellcheck="false">' +
      '<ul class="cfs-phone__list" role="listbox" tabindex="-1" id="' + id + '-list"></ul><p class="cfs-phone__empty" role="status" hidden></p>';
    var row = el.querySelector('.cfs-phone__row');
    row.parentNode.insertBefore(p, row.nextSibling);
    r.search = p.querySelector('input');
    r.list = p.querySelector('ul');
    r.empty = p.querySelector('p');
    var sl = el.getAttribute('data-search-label') || 'Search country or code';
    r.search.setAttribute('placeholder', sl);
    r.search.setAttribute('aria-label', sl);
    r.list.setAttribute('aria-label', label);
    r.empty.textContent = el.getAttribute('data-empty-label') || 'No match';

    function esc(e) {
      e.preventDefault();
      e.stopPropagation();
      if (dlg) dlg.cfsEsc = true;
      closePanel(r, true);
    }

    btn.addEventListener('click', function () {
      if (p.hidden) openPanel(r); else closePanel(r, true);
    });
    btn.addEventListener('keydown', function (e) {
      if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && p.hidden) { e.preventDefault(); openPanel(r); }
    });
    r.search.addEventListener('input', function () { filter(r); });
    r.search.addEventListener('keydown', function (e) {
      var k = e.key, n = r.res.length;
      if (e.isComposing) return;
      if (k === 'ArrowDown' || k === 'ArrowUp') {
        e.preventDefault();
        if (n) setActive(r, r.act < 0 ? 0 : (r.act + (k === 'ArrowDown' ? 1 : n - 1)) % n, true);
      } else if (k === 'Enter') {
        e.preventDefault();
        if (r.res[r.act]) choose(r, r.res[r.act]);
      } else if (k === 'Escape') esc(e);
    });
    // Keep focus in the search field while clicking or scrolling the list.
    p.addEventListener('mousedown', function (e) { if (e.target !== r.search) e.preventDefault(); });
    r.list.addEventListener('click', function (e) {
      var o = e.target.closest('[data-iso]');
      if (o) choose(r, byIso[o.getAttribute('data-iso')]);
    });
    r.list.addEventListener('mousemove', function (e) {
      var o = e.target.closest('[data-iso]'), k = o ? [].indexOf.call(r.list.children, o) : -1;
      if (k > -1 && k !== r.act) setActive(r, k, false);
    });
    // Tabbing out closes the panel.
    p.addEventListener('focusout', function (e) {
      var t = e.relatedTarget;
      if (t && t !== btn && !p.contains(t)) closePanel(r, false);
    });

    if (form) form.addEventListener('submit', function () { compose(r); }, true);
    if (dlg && !dlg.cfsPhone) {
      dlg.cfsPhone = true;
      // Escape closes the open list, not the whole dialog. cfsEsc: this key press already closed a list.
      dlg.addEventListener('cancel', function (e) {
        var mine = open && dlg.contains(open.el);
        if (mine || dlg.cfsEsc) {
          e.preventDefault();
          dlg.cfsEsc = false;
          if (mine) closePanel(open, true);
        }
      });
      dlg.addEventListener('keyup', function (e) { if (e.key === 'Escape') dlg.cfsEsc = false; });
    }

    pick(r, byIso[(el.getAttribute('data-default') || '').toUpperCase()] || byIso.CH);
  }

  // Click outside the open picker (button + panel) closes it.
  document.addEventListener('pointerdown', function (e) {
    if (open && !open.btn.contains(e.target) && !open.panel.contains(e.target)) closePanel(open, false);
  }, true);

  function init() {
    [].forEach.call(document.querySelectorAll('[data-cfs-phone]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();